<calcite-tile-group scale="l" alignment="center">
  <calcite-tile
    icon="file-report-generic"
    heading="Closer Document"
    description="Generate a Closer Document for a single property or multiple properties."
    (click)="openCloserDocumentTool()"
  />
</calcite-tile-group>

<router-outlet />
